import { createBaseResourceActions } from '../create-base-resource-actions';
import { PushNotificationTokenResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[PUSH NOTIFICATION TOKEN]';
export const pushNotificationTokenActions =
  createBaseResourceActions<PushNotificationTokenResourceTypeMappings>(
    domainSlug,
  );
